import { calcMonthlyStats } from './turniStats';
import { fetchTurniByMonth, fetchFerieRequests } from '../services/turniService';
import { generateMensialePdf } from './generateTurniPdf';

// Ogni apertura del preview PDF / cambio collaboratore richiede i turni di tutti i mesi
// da gennaio al mese selezionato (fino a 12 fetch a dicembre). Li cache-a per mese così
// il cambio collaboratore entro la stessa sessione del modal non li riscarica.
// clearTurniPdfCache() va chiamata alla chiusura del modal per non mostrare dati stantii.
const monthlyTurniCache = new Map();

export const clearTurniPdfCache = () => monthlyTurniCache.clear();

const fetchMonthCached = async (month) => {
  if (!monthlyTurniCache.has(month)) {
    monthlyTurniCache.set(month, fetchTurniByMonth(month).then(data => data || []).catch(() => []));
  }
  return monthlyTurniCache.get(month);
};

export const computePdfDoc = async (filtered, allDays, turniData, managerFerieList, reperibilitaData) => {
  const selectedMonthStr = allDays[0]?.fullDate?.substring(0, 7);
  const [year, monthNum] = selectedMonthStr
    ? selectedMonthStr.split('-').map(Number)
    : [new Date().getFullYear(), new Date().getMonth() + 1];

  const monthsKeys = Array.from({ length: monthNum }, (_, i) => `${year}-${String(i + 1).padStart(2, '0')}`);
  const [allMonthsTurni, allFerie] = await Promise.all([
    Promise.all(monthsKeys.map(m => fetchMonthCached(m).then(data => [m, data]))).then(Object.fromEntries),
    fetchFerieRequests().catch(() => []),
  ]);

  const cumulativeBalances = {};
  filtered.forEach(user => {
    const uName = `${user.nome} ${user.cognome}`.trim();
    let cumulo = 0;
    monthsKeys.forEach(monthStr => {
      const [y, m] = monthStr.split('-').map(Number);
      const daysInMonth = new Date(y, m, 0).getDate();
      const monthDays = Array.from({ length: daysInMonth }, (_, i) => ({ fullDate: `${monthStr}-${String(i + 1).padStart(2, '0')}` }));
      const stats = calcMonthlyStats(monthDays, allMonthsTurni[monthStr] || [], allFerie, user);
      cumulo += stats.workedHours + stats.ferieHours + stats.permessiHours + stats.malattiaHours + stats.infortunioHours - stats.oreMensiliContratto;
    });
    cumulativeBalances[uName] = +Number(cumulo).toFixed(1);
  });

  return generateMensialePdf({ allDays, collaboratorsList: filtered, turniData, managerFerieList, reperibilitaData: reperibilitaData || [], cumulativeBalances });
};
